import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import { useRouteMatch } from 'react-router-dom';
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { Button, Card, CardContent, FormControl, Select, Grid, InputLabel, TableHead, Typography, TextField, } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import ViewAgendaIcon from '@material-ui/icons/ViewAgenda';
import BlockIcon from '@material-ui/icons/Block';
import { get } from '../../actions/generic-actions';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Utils from '../../utils/utils';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
  table: {
    minWidth: 500,
  },
  button: {
    color: 'blue',
     background: '#e7f103',
     '&:hover': 
     {color: 'white',
      background: '#0f70b7'}
  }
});

const Skills = (props) => {
  
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [skills, setSkills] = useState([]);
  const [filterSkills, setFilterSkills] = useState([]);

  useEffect(() => {
    const getSkills = async() => {
      const response = await get('/skill/');
      setSkills(response.data.skillResponseList);
      setFilterSkills(response.data.skillResponseList);
    };
    getSkills();
  }, []);

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filterSkills.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const defaultValues = {
    "description": '',
    "skillStatus": '',
  };
  const schema = yup.object().shape({
      description: yup.string(),
      skillStatus: yup.string(),
  });
  
  const { register, handleSubmit, } = useForm({
    resolver: yupResolver(schema),
    defaultValues
  });

  const { path } = useRouteMatch();

  const onSubmit = data => {
     var filterData = Utils.arrayFilter(skills, data);
     setFilterSkills(filterData);
  }

  const ver = (id) => {
    alert(id);
  }

  const editar = (id) => {
    props.history.push(`${path}/editar/${id}`)
  }

  const anular = (id) => {
    alert(id);
  }

  return (
    <div style={{marginTop:'20px'}}>
    <Card className={classes.root} style={{margin:'10px'}}>
      <CardContent>
      <form onSubmit={handleSubmit(onSubmit)} className={classes.form} autocomplete="off">
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={2}>
          <Button variant="contained" className={classes.button} onClick={() => props.history.push(`${path}/crear`)}>
            Crear Skill
          </Button>                  
        </Grid>
       
          
          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    type="text"
                    label="Descripción"
                    name="description"
                />
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={6} lg={2}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="outlined-select-estado" className={classes.select}>Estado</InputLabel>
              <Select native fullWidth
                className={classes.select}
                inputRef={register}
                label = "Estado"
                margin="normal"
                name = "skillStatus"
                inputProps = {
                    {
                        name: 'skillStatus',
                        id: 'outlined-select-estado',
                    }
                } >
                <option aria-label = "None" value = "" />
                    <option key="ACTIVO" value="ACTIVO">ACTIVO</option>
                    <option key="INACTIVO" value="INACTIVO">INACTIVO</option>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
          <Button variant="contained" className={classes.button} style={{marginTop:'0px'}}  type="submit">
            Buscar 
          </Button>
          <Grid item xs={12} md={6} lg={2}>
         </Grid>
        </Grid>
       </Grid>  
      </form>
     </CardContent>
      
    </Card>
    
    <Typography component='h3' variant='h4' style={{textAlign:'center'}}>
          Listado de Skills
        </Typography>

    <TableContainer component={Paper} style={{margin:'10px', width: '99%'}}>
    
      <Table className={classes.table} aria-label="custom pagination table">
        <TableHead>
          <TableRow align="right">
            <TableCell>Acciones</TableCell>
            <TableCell>Id</TableCell>
            <TableCell>Descripcion</TableCell>
            <TableCell align="right">Estado</TableCell>
            <TableCell align="right">Categoria</TableCell>
          </TableRow>
          </TableHead>
          <TableBody>
          {(rowsPerPage > 0
            ? filterSkills.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : filterSkills
          ).map((row, index) => (
            <TableRow key={index}>
              <TableCell align="left" style={{minWidth:'120px'}} className={classes.textContainer}>
                  <ViewAgendaIcon onClick={() => ver(row.id)} style={{cursor:'pointer',color: '#00CC00'}}/>&nbsp;&nbsp;
                  <EditIcon onClick={() => editar(row.id)} style={{cursor:'pointer', color: '#0000CC'}}/>&nbsp;&nbsp;
                  <BlockIcon onClick={() => anular(row.id)} style={{cursor:'pointer',color:'#CC0000'}} />
              </TableCell>
              <TableCell component="th" scope="row" style={{ width: 400 }}>
                {row.id}
              </TableCell>
              <TableCell component="th" scope="row" style={{ width: 450 }}>
              {row.description}
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
              {row.skillStatus}
              </TableCell>
              <TableCell style={{ width: 160 }} align="right">
              {row.category.description}
              </TableCell>
            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={filterSkills.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </div>
  );
}

export default withRouter(Skills);